import React from "react";
import Navbar from "../component/Navbar";
import AboutImages from "../component/AboutImages";
import Footer from "../component/Footer";

function About() {
	return (
		<div>
			<Navbar />
			<div
				className="container"
				id="about"
			>
				<h2 className="text-center mt-5">About</h2>
				<div className="row mt-5">
					<div className="col-sm-6">
						<h3 className="mb-3">Santorini</h3>
						<p>
							Santorini is one of the Cyclades islands in the Aegean Sea. It was
							devastated by a volcanic eruption in the 16th century BC. The
							whitewashed, cubiform houses of its 2 principal towns, Fira and
							Oia, cling to cliffs above an underwater caldera (crater). They
							overlook the sea, small islands to the west and beaches made up of
							black, red and white lava pebbles.
						</p>
						<br />
						<h3 className="mb-3">What to expect</h3>
						<p>
							<strong>Language:</strong> Greek, while locals have an
							understanding of English, learning a few phrases will go a long
							way. <br />
							<br />
							<strong>Currency:</strong> Greece uses the Euro (€) like most
							European countries <br />
							<br />
							<strong>Fly to:</strong> Santorini Airport (JTR), which is located
							on the east of the island. <br />
							<br />
							<strong>Weather: </strong>Average temperatures range from 12 °C in
							January to 26˚C between July and August. <br />
							<br />
							<strong>Best time to visit: </strong>The island has a sunny
							Mediterranean climate, with the warm weather kicking in from April
							and reaching its peak around August. Expect long hours of sunshine
							and beautiful beach weather between May and September.
							<br />
							<br />
						</p>
					</div>

					<div className="col-sm-6 d-flex">
						<img
							className="img-fluid"
							src="https://s3.amazonaws.com/shecodesio-production/uploads/files/000/081/660/original/santorini.jpg?1683930990"
							alt="Santorini"
						/>
					</div>
				</div>
			</div>

			<div className="santorini-images mt-5">
				<div className="container images d-flex justify-content-around">
					<AboutImages />
				</div>
			</div>
			<Footer />
		</div>
	);
}

export default About;
